<template>
  <div id="app">
    <img src="./assets/logo.png" />
    <div v-if="showPasswordDialog" id="password-form">
      <input type="text" v-model="passwordInput" />
      <button @click="onPasswordHandler">authenticate</button>
    </div>
    <div v-if="showActionDialog" id="action-form">
      <input type="number" v-model="roomIdInput" />
      <button @click="onJoinHandler">join</button>
      <button @click="onCreatehandler">create&join</button>
    </div>
    <div v-if="showVideoContainer" class="container hide" id="videos">
      <div class="row">
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">
                Local Video
                <span class="label label-primary hide" id="publisher"></span>
              </h3>
            </div>
            <div class="panel-body" id="videolocal"></div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">
                Remote Video #1
                <span class="label label-info hide" id="remote1"></span>
              </h3>
            </div>
            <div class="panel-body relative" id="videoremote1"></div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">
                Remote Video #2
                <span class="label label-info hide" id="remote2"></span>
              </h3>
            </div>
            <div class="panel-body relative" id="videoremote2"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">
                Remote Video #3
                <span class="label label-info hide" id="remote3"></span>
              </h3>
            </div>
            <div class="panel-body relative" id="videoremote3"></div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">
                Remote Video #4
                <span class="label label-info hide" id="remote4"></span>
              </h3>
            </div>
            <div class="panel-body relative" id="videoremote4"></div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="panel panel-default">
            <div class="panel-heading">
              <h3 class="panel-title">
                Remote Video #5
                <span class="label label-info hide" id="remote5"></span>
              </h3>
            </div>
            <div class="panel-body relative" id="videoremote5"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoRoom from "./components/VideoRoom";
import Janus from "./utils/janus.js";
import adapter from "webrtc-adapter";

export default {
  name: "App",
  data() {
    return {
      passwordInput: null,
      janus: null,
      opaqueId: "videoroomtest-" + "lera",
      creatingSubscription: null,
      remoteFeed: null,
      roomIdInput: null,
      showPasswordDialog: true,
      showActionDialog: false,
      join: false,
      acodec: null,
      mystream: null,
      myusername: "lera",
      myid: null,
      vcodec: null,
      sfutest: null,
      showVideoContainer: false,
      localTracks: {},
      localVideos: 0,
      remoteTracks: {},
      feeds: {},
      feedStreams: {},
      subStreams: {},
      slots: {},
      mids: {},
      subscriptions: {},
      simulcastStarted: {},
      bitrateTimer: [],
      mypvtid: null,
      stream: null,
      roomId: null,
    };
  },
  methods: {
    onPasswordHandler() {
      if(this.passwordInput == "bananakoko"){
        this.showPasswordDialog = false;
        this.showActionDialog = true;
      }
    },
    onJoinHandler() {
      this.showActionDialog = false;
      this.join = true;
      this.initializeJanusInstance();
    },
    onCreatehandler() {
      this.showActionDialog = false;
      this.initializeJanusInstance();
    },
    initializeJanusInstance() {
      var videoroom = null;
      Janus.init({
        debug: "all",
        dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
        callback: function () {
          console.log("init");

          //creates session
          this.janus = new Janus({
            server: "https://api.janus2.invrtual.de/janus",
            iceServers: [{urls: "stun:stun.l.google.com:19302"}],
            success: function () {
              console.log("lera");

              //attaches videoroom plugin
              videoroom = this.janus.attach({
                plugin: "janus.plugin.videoroom",
                opaqueId: this.opaqueId,
                success: function (pluginHandle) {
                  console.log("plugin attached");
                  console.log(pluginHandle.id);
                  console.log(Janus.sessions);
                  this.sfutest = pluginHandle;

                  if (!this.join) {
                    // create room
                    var register = {
                      request: "create",
                      room: pluginHandle.id,
                      publishers: 50,
                      is_private: false,
                      //   ptype: "publisher",
                      //   display: 'bananakoko'
                    };

                    pluginHandle.send({ message: register });
                  }
                  Janus.log(
                    "Plugin attached! (" +
                      pluginHandle.getPlugin() +
                      ", id=" +
                      pluginHandle.getId() +
                      ")"
                  );
                  this.roomId = pluginHandle.getId();

                  this.showVideoContainer = true;
                  console.log('pluginHandle.id',pluginHandle.id);
                  console.log('roomidinput',this.roomIdInput);
                  try {
                    let join = {
                      request: "join",
                      room: this.join ? +this.roomIdInput : pluginHandle.id,
                      // is_private : "false",
                      ptype: "publisher",
                      display: "bananakoko",
                    };
                    pluginHandle.send({ message: join });
                  } catch (error) {
                    console.log("error!", error);
                  }

                  console.log(this.showVideoContainer);
                }.bind(this),
                error: function (error) {
                  Janus.error("  -- Error attaching plugin...", error);
                  console.log("Error attaching plugin... " + error);
                }.bind(this),
                iceState: function (state) {
                  Janus.log("ICE state changed to " + state);
                }.bind(this),
                mediaState: function (medium, on, mid) {
                  Janus.log(
                    "Janus " +
                      (on ? "started" : "stopped") +
                      " receiving our " +
                      medium +
                      " (mid=" +
                      mid +
                      ")"
                  );
                }.bind(this),
                onmessage: function (msg, jsep) {
                  Janus.debug(" ::: Got a message (publisher) :::", msg);
                  let event = msg["videoroom"];
                  Janus.debug("Event: " + event);
                  if (event != undefined && event != null) {
                    if (event === "joined") {
                      console.log("joinedVideoroom");
                      // Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any
                      this.myid = msg["id"];
                      this.mypvtid = msg["private_id"];
                      Janus.log(
                        "Successfully joined room " +
                          msg["room"] +
                          " with ID " +
                          this.myid
                      );
					            this.roomId = msg["room"];
                      // if(subscriber_mode) {
                      // 	$('#videojoin').hide();
                      // 	$('#videos').removeClass('hide').show();
                      // } else {
                      this.publishOwnFeed(true);
                      // }
                      // Any new feed to attach to?
                      if (msg["publishers"]) {
                        let list = msg["publishers"];
                        Janus.debug(
                          "Got a list of available publishers/feeds:",
                          list
                        );
                        let sources = null;
                        for (let f in list) {
                          if (list[f]["dummy"]) continue;
                          let id = list[f]["id"];
                          let display = list[f]["display"];
                          let streams = list[f]["streams"];
                          for (let i in streams) {
                            let stream = streams[i];
                            stream["id"] = id;
                            stream["display"] = display;
                          }
                          let slot = this.feedStreams[id]
                            ? this.feedStreams[id].slot
                            : null;
                          let remoteVideos = this.feedStreams[id]
                            ? this.feedStreams[id].remoteVideos
                            : 0;
                          this.feedStreams[id] = {
                            id: id,
                            display: display,
                            streams: streams,
                            slot: slot,
                            remoteVideos: remoteVideos,
                          };
                          Janus.debug(
                            "  >> [" + id + "] " + display + ":",
                            streams
                          );
                          if (!sources) sources = [];
                          sources.push(streams);
                        }
                        if (sources) this.subscribeTo(sources);
                      }
                    } else if (event === "destroyed") {
                      // The room has been destroyed
                      Janus.warn("The room has been destroyed!");
                      console.log("The room has been destroyed", function () {
                        window.location.reload();
                      });
                    } else if (event === "event") {
                      // Any info on our streams or a new feed to attach to?
                      if (msg["streams"]) {
                        let streams = msg["streams"];
                        for (let i in streams) {
                          let stream = streams[i];
                          stream["id"] = this.myid;
                          stream["display"] = this.myusername;
                        }
                        this.feedStreams[this.myid] = {
                          id: this.myid,
                          display: this.myusername,
                          streams: streams,
                        };
                      } else if (msg["publishers"]) {
                        let list = msg["publishers"];
                        Janus.debug(
                          "Got a list of available publishers/feeds:",
                          list
                        );
                        let sources = null;
                        for (let f in list) {
                          if (list[f]["dummy"]) continue;
                          let id = list[f]["id"];
                          let display = list[f]["display"];
                          let streams = list[f]["streams"];
                          for (let i in streams) {
                            let stream = streams[i];
                            stream["id"] = id;
                            stream["display"] = display;
                          }
                          let slot = this.feedStreams[id]
                            ? this.feedStreams[id].slot
                            : null;
                          let remoteVideos = this.feedStreams[id]
                            ? this.feedStreams[id].remoteVideos
                            : 0;
                          this.feedStreams[id] = {
                            id: id,
                            display: display,
                            streams: streams,
                            slot: slot,
                            remoteVideos: remoteVideos,
                          };
                          Janus.debug(
                            "  >> [" + id + "] " + display + ":",
                            streams
                          );
                          if (!sources) sources = [];
                          sources.push(streams);
                        }
                        if (sources) this.subscribeTo(sources);
                      } else if (msg["leaving"]) {
                        // One of the publishers has gone away?
                        let leaving = msg["leaving"];
                        Janus.log("Publisher left: " + leaving);
                        unsubscribeFrom(leaving);
                      } else if (msg["unpublished"]) {
                        // One of the publishers has unpublished?
                        let unpublished = msg["unpublished"];
                        Janus.log("Publisher left: " + unpublished);
                        if (unpublished === "ok") {
                          // That's us
                          this.sfutest.hangup();
                          return;
                        }
                        unsubscribeFrom(unpublished);
                      } else if (msg["error"]) {
                        if (msg["error_code"] === 426) {
                          // This is a "no such room" error: give a more meaningful description

                          console.log(msg["error"]);
                        } else {
                          console.log(msg["error"]);
                        }
                      }
                    }
                  }
                  if (jsep) {
                    Janus.debug("Handling SDP as well...", jsep);
                    this.sfutest.handleRemoteJsep({ jsep: jsep });
                    // Check if any of the media we wanted to publish has
                    // been rejected (e.g., wrong or unsupported codec)
                    let audio = msg["audio_codec"];
                    if (
                      this.mystream &&
                      this.mystream.getAudioTracks() &&
                      this.mystream.getAudioTracks().length > 0 &&
                      !audio
                    ) {
                      // Audio has been rejected
                      toastr.warning(
                        "Our audio stream has been rejected, viewers won't hear us"
                      );
                    }
                    let video = msg["video_codec"];
                    if (
                      this.mystream &&
                      this.mystream.getVideoTracks() &&
                      this.mystream.getVideoTracks().length > 0 &&
                      !video
                    ) {
                      // Video has been rejected
                      toastr.warning(
                        "Our video stream has been rejected, viewers won't see us"
                      );
                      // Hide the webcam video
                      $("#myvideo").hide();
                      $("#videolocal").append(
                        '<div class="no-video-container">' +
                          '<i class="fa fa-video-camera fa-5 no-video-icon" style="height: 100%;"></i>' +
                          '<span class="no-video-text" style="font-size: 16px;">Video rejected, no webcam</span>' +
                          "</div>"
                      );
                    }
                  }
                }.bind(this),
                onlocaltrack: function (track, on) {
                  Janus.debug(" ::: Got a local track event :::");
                  Janus.debug(
                    "Local track " + (on ? "added" : "removed") + ":",
                    track
                  );
                  // We use the track ID as name of the element, but it may contain invalid characters
                  let trackId = track.id.replace(/[{}]/g, "");
                  if (!on) {
                    // Track removed, get rid of the stream and the rendering
                    let stream = this.localTracks[trackId];
                    if (stream) {
                      try {
                        let tracks = stream.getTracks();
                        for (let i in tracks) {
                          let mst = tracks[i];
                          if (mst) mst.stop();
                        }
                      } catch (e) {}
                    }
                    if (track.kind === "video") {
                      $("#myvideo" + trackId).remove();
                      this.localVideos--;
                      if (this.localVideos === 0) {
                        // No video, at least for now: show a placeholder
                        if ($("#videolocal .no-video-container").length === 0) {
                          $("#videolocal").append(
                            '<div class="no-video-container">' +
                              '<i class="fa fa-video-camera fa-5 no-video-icon"></i>' +
                              '<span class="no-video-text">No webcam available</span>' +
                              "</div>"
                          );
                        }
                      }
                    }
                    delete this.localTracks[trackId];
                    return;
                  }
                  // If we're here, a new track was added
                  let stream = this.localTracks[trackId];
                  if (stream) {
                    // We've been here already
                    return;
                  }
                  $("#videos").removeClass("hide").show();
                  if ($("#mute").length === 0) {
                    // Add a 'mute' button
                    $("#videolocal").append(
                      '<button class="btn btn-warning btn-xs" id="mute" style="position: absolute; bottom: 0px; left: 0px; margin: 15px;">Mute</button>'
                    );
                    // $('#mute').click(toggleMute);
                    // Add an 'unpublish' button
                    $("#videolocal").append(
                      '<button class="btn btn-warning btn-xs" id="unpublish" style="position: absolute; bottom: 0px; right: 0px; margin: 15px;">Unpublish</button>'
                    );
                    // $('#unpublish').click(unpublishOwnFeed);
                  }
                  if (track.kind === "audio") {
                    // We ignore local audio tracks, they'd generate echo anyway
                    if (this.localVideos === 0) {
                      // No video, at least for now: show a placeholder
                      if ($("#videolocal .no-video-container").length === 0) {
                        $("#videolocal").append(
                          '<div class="no-video-container">' +
                            '<i class="fa fa-video-camera fa-5 no-video-icon"></i>' +
                            '<span class="no-video-text">No webcam available</span>' +
                            "</div>"
                        );
                      }
                    }
                  } else {
                    // New video track: create a stream out of it
                    this.localVideos++;
                    $("#videolocal .no-video-container").remove();
                    let stream = new MediaStream([track]);
                    this.localTracks[trackId] = stream;
                    Janus.log("Created local stream:", stream);
                    Janus.log(stream.getTracks());
                    Janus.log(stream.getVideoTracks());
                    $("#videolocal").append(
                      '<video class="rounded centered" id="myvideo' +
                        trackId +
                        '" width=100% autoplay playsinline muted="muted"/>'
                    );
                    Janus.attachMediaStream(
                      $("#myvideo" + trackId).get(0),
                      stream
                    );
                  }
                  if (
                    this.sfutest.webrtcStuff.pc.iceConnectionState !==
                      "completed" &&
                    this.sfutest.webrtcStuff.pc.iceConnectionState !==
                      "connected"
                  ) {
                    // $("#videolocal").parent().parent().block({
                    // 	message: '<b>Publishing...</b>',
                    // 	css: {
                    // 		border: 'none',
                    // 		backgroundColor: 'transparent',
                    // 		color: 'white'
                    // 	}
                    // });
                  }
                }.bind(this),
                onremotetrack: function (track, mid, on) {
                  // The publisher stream is sendonly, we don't expect anything here
                }.bind(this),
              });
            }.bind(this),
            onmessage: function (msg, jsep) {
              Janus.debug(" ::: Got a message (publisher) :::", msg);
              let event = msg["videoroom"];
              Janus.debug("Event: " + event);
              if (event != undefined && event != null) {
                if (event === "joined") {
                  // Publisher/manager created, negotiate WebRTC and attach to existing feeds, if any
                  myid = msg["id"];
                  mypvtid = msg["private_id"];
                  Janus.log(
                    "Successfully joined room " +
                      msg["room"] +
                      " with ID " +
                      myid
                  );
				  this.roomId = msg["room"];

                  if (subscriber_mode) {
                    $("#videojoin").hide();
                    $("#videos").removeClass("hide").show();
                  } else {
                    publishOwnFeed(true);
                  }
                  // Any new feed to attach to?
                  if (msg["publishers"]) {
                    let list = msg["publishers"];
                    Janus.debug(
                      "Got a list of available publishers/feeds:",
                      list
                    );
                    let sources = null;
                    for (let f in list) {
                      if (list[f]["dummy"]) continue;
                      let id = list[f]["id"];
                      let display = list[f]["display"];
                      let streams = list[f]["streams"];
                      for (let i in streams) {
                        let stream = streams[i];
                        stream["id"] = id;
                        stream["display"] = display;
                      }
                      let slot = feedStreams[id] ? feedStreams[id].slot : null;
                      let remoteVideos = feedStreams[id]
                        ? feedStreams[id].remoteVideos
                        : 0;
                      feedStreams[id] = {
                        id: id,
                        display: display,
                        streams: streams,
                        slot: slot,
                        remoteVideos: remoteVideos,
                      };
                      Janus.debug(
                        "  >> [" + id + "] " + display + ":",
                        streams
                      );
                      if (!sources) sources = [];
                      sources.push(streams);
                    }
                    if (sources) subscribeTo(sources);
                  }
                } else if (event === "destroyed") {
                  // The room has been destroyed
                  Janus.warn("The room has been destroyed!");
                  bootbox.alert("The room has been destroyed", function () {
                    window.location.reload();
                  });
                } else if (event === "event") {
                  // Any info on our streams or a new feed to attach to?
                  if (msg["streams"]) {
                    let streams = msg["streams"];
                    for (let i in streams) {
                      let stream = streams[i];
                      stream["id"] = this.myid;
                      stream["display"] = this.myusername;
                    }
                    feedStreams[this.myid] = {
                      id: this.myid,
                      display: this.myusername,
                      streams: streams,
                    };
                  } else if (msg["publishers"]) {
                    let list = msg["publishers"];
                    Janus.debug(
                      "Got a list of available publishers/feeds:",
                      list
                    );
                    let sources = null;
                    for (let f in list) {
                      if (list[f]["dummy"]) continue;
                      let id = list[f]["id"];
                      let display = list[f]["display"];
                      let streams = list[f]["streams"];
                      for (let i in streams) {
                        let stream = streams[i];
                        stream["id"] = id;
                        stream["display"] = display;
                      }
                      let slot = feedStreams[id] ? feedStreams[id].slot : null;
                      let remoteVideos = feedStreams[id]
                        ? feedStreams[id].remoteVideos
                        : 0;
                      feedStreams[id] = {
                        id: id,
                        display: display,
                        streams: streams,
                        slot: slot,
                        remoteVideos: remoteVideos,
                      };
                      Janus.debug(
                        "  >> [" + id + "] " + display + ":",
                        streams
                      );
                      if (!sources) sources = [];
                      sources.push(streams);
                    }
                    if (sources) subscribeTo(sources);
                  } else if (msg["leaving"]) {
                    // One of the publishers has gone away?
                    let leaving = msg["leaving"];
                    Janus.log("Publisher left: " + leaving);
                    unsubscribeFrom(leaving);
                  } else if (msg["unpublished"]) {
                    // One of the publishers has unpublished?
                    let unpublished = msg["unpublished"];
                    Janus.log("Publisher left: " + unpublished);
                    if (unpublished === "ok") {
                      // That's us
                      sfutest.hangup();
                      return;
                    }
                    unsubscribeFrom(unpublished);
                  } else if (msg["error"]) {
                    if (msg["error_code"] === 426) {
                      // This is a "no such room" error: give a more meaningful description
                      bootbox.alert(
                        "<p>Apparently room <code>" +
                          myroom +
                          "</code> (the one this demo uses as a test room) " +
                          "does not exist...</p><p>Do you have an updated <code>janus.plugin.videoroom.cfg</code> " +
                          "configuration file? If not, make sure you copy the details of room <code>" +
                          myroom +
                          "</code> " +
                          "from that sample in your current configuration file, then restart Janus and try again."
                      );
                    } else {
                      bootbox.alert(msg["error"]);
                    }
                  }
                }
              }
              if (jsep) {
                Janus.debug("Handling SDP as well...", jsep);
                sfutest.handleRemoteJsep({ jsep: jsep });
                // Check if any of the media we wanted to publish has
                // been rejected (e.g., wrong or unsupported codec)
                let audio = msg["audio_codec"];
                if (
                  mystream &&
                  mystream.getAudioTracks() &&
                  mystream.getAudioTracks().length > 0 &&
                  !audio
                ) {
                  // Audio has been rejected
                  toastr.warning(
                    "Our audio stream has been rejected, viewers won't hear us"
                  );
                }
                let video = msg["video_codec"];
                if (
                  mystream &&
                  mystream.getVideoTracks() &&
                  mystream.getVideoTracks().length > 0 &&
                  !video
                ) {
                  // Video has been rejected
                  toastr.warning(
                    "Our video stream has been rejected, viewers won't see us"
                  );
                  // Hide the webcam video
                  $("#myvideo").hide();
                  $("#videolocal").append(
                    '<div class="no-video-container">' +
                      '<i class="fa fa-video-camera fa-5 no-video-icon" style="height: 100%;"></i>' +
                      '<span class="no-video-text" style="font-size: 16px;">Video rejected, no webcam</span>' +
                      "</div>"
                  );
                }
              }
            },
          });
        }.bind(this),
      });
    },
    publishOwnFeed(useAudio) {
      // Publish our stream
      // $('#publish').attr('disabled', true).unbind('click');

      // We want sendonly audio and video (uncomment the data track
      // too if you want to publish via datachannels as well)
      let tracks = [];
      if (useAudio) tracks.push({ type: "audio", capture: true, recv: true });
      tracks.push({
        type: "video",
        capture: true,
        recv: true,
        simulcast: true,
      });
      //~ tracks.push({ type: 'data' });

      this.sfutest.createOffer({
        tracks: tracks,
        success: function (jsep) {
          Janus.debug("Got publisher SDP!");
          Janus.debug(jsep);
          let publish = { request: "configure", audio: useAudio, video: true };
          // You can force a specific codec to use when publishing by using the
          // audiocodec and videocodec properties, for instance:
          // 		publish["audiocodec"] = "opus"
          // to force Opus as the audio codec to use, or:
          // 		publish["videocodec"] = "vp9"
          // to force VP9 as the videocodec to use. In both case, though, forcing
          // a codec will only work if: (1) the codec is actually in the SDP (and
          // so the browser supports it), and (2) the codec is in the list of
          // allowed codecs in a room. With respect to the point (2) above,
          // refer to the text in janus.plugin.videoroom.cfg for more details
          if (this.acodec) publish["audiocodec"] = this.acodec;
          if (this.vcodec) publish["videocodec"] = this.vcodec;
          this.sfutest.send({ message: publish, jsep: jsep });
        }.bind(this),
        error: function (error) {
          Janus.error("WebRTC error:", error);
          if (useAudio) {
            this.publishOwnFeed(false);
          } else {
            console.log("WebRTC error... " + error.message);
            this.publishOwnFeed(true);
          }
        }.bind(this),
      });
    },

    subscribeTo(sources) {
      this.creatingSubscription = false;
      // Check if we're still creating the subscription handle
      if (this.creatingSubscription) {
        // Still working on the handle, send this request later when it's ready
        setTimeout(function () {
          subscribeTo(sources);
        }, 500);
        return;
      }
      // If we already have a working subscription handle, just update that one
      if (this.remoteFeed) {
        // Prepare the streams to subscribe to, as an array: we have the list of
        // streams the feeds are publishing, so we can choose what to pick or skip
        let added = null,
          removed = null;
        for (let s in sources) {
          let streams = sources[s];
          for (let i in streams) {
            let stream = streams[i];
            // If the publisher is VP8/VP9 and this is an older Safari, let's avoid video
            if (
              stream.type === "video" &&
              Janus.webRTCAdapter.browserDetails.browser === "safari" &&
              (stream.codec === "vp9" ||
                (stream.codec === "vp8" && !Janus.safariVp8))
            ) {
              toastr.warning(
                "Publisher is using " +
                  stream.codec.toUpperCase +
                  ", but Safari doesn't support it: disabling video stream #" +
                  stream.mindex
              );
              continue;
            }

            console.log("subsc");
            if (stream.disabled) {
              Janus.log("Disabled stream:", stream);
              // Unsubscribe
              if (!removed) removed = [];
              removed.push({
                feed: stream.id, // This is mandatory
                mid: stream.mid, // This is optional (all streams, if missing)
              });
              delete this.subscriptions[stream.id][stream.mid];
              continue;
            }
            if (
              this.subscriptions[stream.id] &&
              this.subscriptions[stream.id][stream.mid]
            ) {
              Janus.log("Already subscribed to stream, skipping:", stream);
              continue;
            }
            // Find an empty slot in the UI for each new source
            if (!this.feedStreams[stream.id].slot) {
              let slot;
              for (let i = 1; i < 6; i++) {
                if (!this.feeds[i]) {
                  slot = i;
                  this.feeds[slot] = stream.id;
                  this.feedStreams[stream.id].slot = slot;
                  this.feedStreams[stream.id].remoteVideos = 0;
                  //   $("#remote" + slot)
                  //     .removeClass("hide")
                  //     .html(escapeXmlTags(stream.display))
                  //     .show();
                  break;
                }
              }
            }
            // Subscribe
            if (!added) added = [];
            added.push({
              feed: stream.id, // This is mandatory
              mid: stream.mid, // This is optional (all streams, if missing)
            });
            if (!this.subscriptions[stream.id])
              this.subscriptions[stream.id] = {};
            this.subscriptions[stream.id][stream.mid] = true;
          }
        }
        if (
          (!added || added.length === 0) &&
          (!removed || removed.length === 0)
        ) {
          // Nothing to do
          return;
        }
        let update = { request: "update" };
        if (added) update.subscribe = added;
        if (removed) update.unsubscribe = removed;
        this.remoteFeed.send({ message: update });
        // Nothing else we need to do
        return;
      }
      // If we got here, we're creating a new handle for the subscriptions (we only need one)
      this.creatingSubscription = true;
      this.janus.attach({
        plugin: "janus.plugin.videoroom",
        opaqueId: this.opaqueId,
        success: function (pluginHandle) {
          this.remoteFeed = pluginHandle;
          this.remoteTracks = {};
          Janus.log(
            "Plugin attached! (" +
              this.remoteFeed.getPlugin() +
              ", id=" +
              this.remoteFeed.getId() +
              ")"
          );
          Janus.log("  -- This is a multistream subscriber");
          // Prepare the streams to subscribe to, as an array: we have the list of
          // streams the feed is publishing, so we can choose what to pick or skip
          let subscription = [];
          for (let s in sources) {
            let streams = sources[s];
            for (let i in streams) {
              let stream = streams[i];
              // If the publisher is VP8/VP9 and this is an older Safari, let's avoid video
              if (
                stream.type === "video" &&
                Janus.webRTCAdapter.browserDetails.browser === "safari" &&
                (stream.codec === "vp9" ||
                  (stream.codec === "vp8" && !Janus.safariVp8))
              ) {
                toastr.warning(
                  "Publisher is using " +
                    stream.codec.toUpperCase +
                    ", but Safari doesn't support it: disabling video stream #" +
                    stream.mindex
                );
                continue;
              }
              if (stream.disabled) {
                Janus.log("Disabled stream:", stream);
                // TODO Skipping for now, we should unsubscribe
                continue;
              }
              Janus.log(
                "Subscribed to " + stream.id + "/" + stream.mid + "?",
                this.subscriptions
              );
              if (
                this.subscriptions[stream.id] &&
                this.subscriptions[stream.id][stream.mid]
              ) {
                Janus.log("Already subscribed to stream, skipping:", stream);
                continue;
              }
              // Find an empty slot in the UI for each new source
              if (!this.feedStreams[stream.id].slot) {
                let slot;
                for (let i = 1; i < 6; i++) {
                  if (!this.feeds[i]) {
                    slot = i;
                    this.feeds[slot] = stream.id;
                    this.feedStreams[stream.id].slot = slot;
                    this.feedStreams[stream.id].remoteVideos = 0;
                    //   $("#remote" + slot)
                    //     .removeClass("hide")
                    //     .html(escapeXmlTags(stream.display))
                    //     .show();
                    break;
                  }
                }
              }
              subscription.push({
                feed: stream.id, // This is mandatory
                mid: stream.mid, // This is optional (all streams, if missing)
              });
              if (!this.subscriptions[stream.id])
                this.subscriptions[stream.id] = {};
              this.subscriptions[stream.id][stream.mid] = true;
            }
          }
          // We wait for the plugin to send us an offer
		  console.log('subscribe',this.roomId);
          let subscribe = {
            request: "join",
            room: +this.roomId,
            ptype: "subscriber",
            streams: subscription,
            use_msid: "false",
            private_id: this.mypvtid,
          };
          this.remoteFeed.send({ message: subscribe });
        }.bind(this),
        error: function (error) {
          Janus.error("  -- Error attaching plugin...", error);
          // console.log("Error attaching plugin... " + error);
        },
        iceState: function (state) {
          Janus.log("ICE state (remote feed) changed to " + state);
        },
        webrtcState: function (on) {
          Janus.log(
            "Janus says this WebRTC PeerConnection (remote feed) is " +
              (on ? "up" : "down") +
              " now"
          );
        },
        slowLink: function (uplink, lost, mid) {
          Janus.warn(
            "Janus reports problems " +
              (uplink ? "sending" : "receiving") +
              " packets on mid " +
              mid +
              " (" +
              lost +
              " lost packets)"
          );
        },
        onmessage: function (msg, jsep) {
          console.log(" ::: Got a message (subscriber) :::", msg);
          Janus.debug(" ::: Got a message (subscriber) :::", msg);
          let event = msg["videoroom"];
          Janus.debug("Event: " + event);
          if (msg["error"]) {
            console.log(msg["error"]);
          } else if (event) {
            if (event === "attached") {
              // Now we have a working subscription, next requests will update this one
              this.creatingSubscription = false;
              Janus.log("Successfully attached to feed in room " + msg["room"]);
            } else if (event === "event") {
              // Check if we got an event on a simulcast-related event from this publisher
              let mid = msg["mid"];
              let substream = msg["substream"];
              let temporal = msg["temporal"];
              if (
                (substream !== null && substream !== undefined) ||
                (temporal !== null && temporal !== undefined)
              ) {
                // Check which this feed this refers to
                let sub = this.subStreams[mid];
                let feed = this.feedStreams[sub.feed_id];
                let slot = this.slots[mid];
                if (!this.simulcastStarted[slot]) {
                  this.simulcastStarted[slot] = true;
                  // Add some new buttons
                  // addSimulcastButtons(slot, true);
                }
                // We just received notice that there's been a switch, update the buttons
                //   updateSimulcastButtons(slot, substream, temporal);
              }
            } else {
              // What has just happened?
            }
          }
          if (msg["streams"]) {
            // Update map of subscriptions by mid
            for (let i in msg["streams"]) {
              let mid = msg["streams"][i]["mid"];
              this.subStreams[mid] = msg["streams"][i];
              let feed = this.feedStreams[msg["streams"][i]["feed_id"]];
              if (feed && feed.slot) {
                this.slots[mid] = feed.slot;
                this.mids[feed.slot] = mid;
              }
            }
          }
          if (jsep) {
            Janus.debug("Handling SDP as well...", jsep);
            // Answer and attach
            this.remoteFeed.createAnswer({
              jsep: jsep,
              // We only specify data channels here, as this way in
              // case they were offered we'll enable them. Since we
              // don't mention audio or video tracks, we autoaccept them
              // as recvonly (since we won't capture anything ourselves)
              tracks: [{ type: "data" }],
              success: function (jsep) {
                Janus.debug("Got SDP!");
                Janus.debug(jsep);
                let body = { request: "start", room: this.roomId };
                this.remoteFeed.send({ message: body, jsep: jsep });
              }.bind(this),
              error: function (error) {
                Janus.error("WebRTC error:", error);
                console.log("WebRTC error... " + error.message);
              },
            });
          }
        }.bind(this),
        onlocaltrack: function (track, on) {
          // The subscriber stream is recvonly, we don't expect anything here
        },
        onremotetrack: function (track, mid, on) {
          Janus.debug(
            "Remote track (mid=" +
              mid +
              ") " +
              (on ? "added" : "removed") +
              ":",
            track
          );
          // Which publisher are we getting on this mid?
          let sub = this.subStreams[mid];
          let feed = this.feedStreams[sub.feed_id];
          Janus.debug(
            " >> This track is coming from feed " + sub.feed_id + ":",
            feed
          );
          let slot = this.slots[mid];
          if (feed && !slot) {
            slot = feed.slot;
            this.slots[mid] = feed.slot;
            this.mids[feed.slot] = mid;
          }
          Janus.debug(" >> mid " + mid + " is in slot " + slot);
          if (!on) {
            // Track removed, get rid of the stream and the rendering
            $("#remotevideo" + slot + "-" + mid).remove();
            if (track.kind === "video" && feed) {
              feed.remoteVideos--;
              if (feed.remoteVideos === 0) {
                // No video, at least for now: show a placeholder
                if (
                  $("#videoremote" + slot + " .no-video-container").length === 0
                ) {
                  $("#videoremote" + slot).append(
                    '<div class="no-video-container">' +
                      '<i class="fa fa-video-camera fa-5 no-video-icon"></i>' +
                      '<span class="no-video-text">No remote video available</span>' +
                      "</div>"
                  );
                }
              }
            }
            delete this.remoteTracks[mid];
            delete this.slots[mid];
            delete this.mids[slot];
            return;
          }
          // If we're here, a new track was added
          if (feed.spinner) {
            feed.spinner.stop();
            feed.spinner = null;
          }
          if ($("#remotevideo" + slot + "-" + mid).length > 0) return;
          if (track.kind === "audio") {
            // New audio track: create a stream out of it, and use a hidden <audio> element
            let stream = new MediaStream([track]);
            this.remoteTracks[mid] = stream;
            Janus.log("Created remote audio stream:", stream);
            $("#videoremote" + slot).append(
              '<audio class="hide" id="remotevideo' +
                slot +
                "-" +
                mid +
                '" autoplay playsinline/>'
            );
            Janus.attachMediaStream(
              $("#remotevideo" + slot + "-" + mid).get(0),
              stream
            );
            if (feed.remoteVideos === 0) {
              // No video, at least for now: show a placeholder
              if (
                $("#videoremote" + slot + " .no-video-container").length === 0
              ) {
                $("#videoremote" + slot).append(
                  '<div class="no-video-container">' +
                    '<i class="fa fa-video-camera fa-5 no-video-icon"></i>' +
                    '<span class="no-video-text">No remote video available</span>' +
                    "</div>"
                );
              }
            }
          } else {
            // New video track: create a stream out of it
            feed.remoteVideos++;
            $("#videoremote" + slot + " .no-video-container").remove();
            let stream = new MediaStream([track]);
            this.remoteTracks[mid] = stream;
            Janus.log("Created remote video stream:", stream);
            $("#videoremote" + slot).append(
              '<video class="rounded centered" id="remotevideo' +
                slot +
                "-" +
                mid +
                '" width=100% autoplay playsinline/>'
            );
            $("#videoremote" + slot).append(
              '<span class="label label-primary hide" id="curres' +
                slot +
                '" style="position: absolute; bottom: 0px; left: 0px; margin: 15px;"></span>' +
                '<span class="label label-info hide" id="curbitrate' +
                slot +
                '" style="position: absolute; bottom: 0px; right: 0px; margin: 15px;"></span>'
            );
            Janus.attachMediaStream(
              $("#remotevideo" + slot + "-" + mid).get(0),
              stream
            );
            // Note: we'll need this for additional videos too
            //   if (!this.bitrateTimer[slot]) {
            //     $("#curbitrate" + slot)
            //       .removeClass("hide")
            //       .show();
            //     this.bitrateTimer[slot] = setInterval(function () {
            //       if (!$("#videoremote" + slot + " video").get(0)) return;
            //       // Display updated bitrate, if supported
            //       let bitrate = this.remoteFeed.getBitrate(mid);
            //       $("#curbitrate" + slot).text(bitrate);
            //       // Check if the resolution changed too
            //       let width = $("#videoremote" + slot + " video").get(
            //         0
            //       ).videoWidth;
            //       let height = $("#videoremote" + slot + " video").get(
            //         0
            //       ).videoHeight;
            //       if (width > 0 && height > 0)
            //         $("#curres" + slot)
            //           .removeClass("hide")
            //           .text(width + "x" + height)
            //           .show();
            //     }, 1000);
            //   }
          }
        }.bind(this),
        oncleanup: function () {
          Janus.log(" ::: Got a cleanup notification (remote feed) :::");
          for (let i = 1; i < 6; i++) {
            $("#videoremote" + i).empty();
            if (this.bitrateTimer[i]) clearInterval(this.bitrateTimer[i]);
            this.bitrateTimer[i] = null;
            this.feedStreams[i].simulcastStarted = false;
            this.feedStreams[i].remoteVideos = 0;
            $("#simulcast" + i).remove();
          }
          this.remoteTracks = {};
        }.bind(this),
      });
    },
  },
  mounted() {
    // console.log(Janus.attach);
    // new Janus({server:'http://127.0.0.1:8088/janus',iceServers: null,success:function(){
    //   console.log('lera');
    // }})
  },
  components: {
    VideoRoom,
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
@import "~bootstrap/dist/css/bootstrap.css";
</style>



// WEBPACK FOOTER //
// src/App.vue